import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 has-text-centered is-size-5" }, "NH Primary Campaign, January 2024", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("canvas", { id: "barChart" }, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_3))
}